import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'local-seo-info-banner',
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
  standalone: false,
})
export class InfoBannerComponent {
  @Input() title: string;
  @Input() imageURL: string;
  @Input() description: string;
  @Input() buttonText: string;
  @Output() buttonClick = new EventEmitter<void>();
  open = true;

  toggle() {
    this.open = !this.open;
  }
}
